import React, { useState } from 'react';

// Datos de ejemplo para la Bibliografía (Diseñado para escalar hasta 100 PDFs)
const pdfLibraryData = Array.from({ length: 100 }, (_, index) => ({
  id: index + 1,
  title: `Documento Sagrado / Texto Místico N° ${index + 1}`,
  description: `Enseñanzas profundas sobre meditación, energía y expansión de la consciencia contenidas en el volumen ${index + 1}.`,
  fileSize: `${(Math.random() * 3 + 1).toFixed(1)} MB`,
  downloadLink: "#"
}));

// Datos de ejemplo para los Videos (Diseñado para escalar hasta 100 videos)
const videoLibraryData = Array.from({ length: 100 }, (_, index) => ({
  id: index + 1,
  title: `Conferencia de Consciencia N° ${index + 1}`,
  duration: `${Math.floor(Math.random() * 40 + 10)} min`,
  description: `Sesión de conexión interior, alineación energética y sabiduría estelar correspondiente al encuentro ${index + 1}.`,
  videoUrl: "https://www.w3schools.com/html/mov_bbb.mp4"
}));

const photoGallery = [
  { title: "Sintetizando la Luz", img: "https://images.unsplash.com/photo-1518241353330-0f7941c2d9b5?auto=format&fit=crop&w=600&q=80" },
  { title: "Geometría Sagrada", img: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=80" },
  { title: "Sendero de Paz", img: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=600&q=80" },
  { title: "Armonía Universal", img: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=600&q=80" }
];

export default function SpiritualApp() {
  const [activeTab, setActiveTab] = useState('home');

  return (
    <div style={{ 
      minHeight: '100vh', 
      backgroundImage: `linear-gradient(rgba(10, 10, 25, 0.75), rgba(10, 10, 25, 0.85)), url('/fondo-espiritual.jpg')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundAttachment: 'fixed',
      color: '#e2e8f0',
      fontFamily: 'system-ui, -apple-system, sans-serif', 
      display: 'flex', 
      flexDirection: 'column',
      width: '100%'
    }}>
      
      {/* ENCABEZADO ESPIRITUAL */}
      <header style={{ 
        position: 'sticky', 
        top: 0, 
        zIndex: 100, 
        backgroundColor: 'rgba(10, 10, 25, 0.85)', 
        backdropFilter: 'blur(10px)', 
        borderBottom: '1px solid rgba(168, 85, 247, 0.3)' 
      }}>
        <div style={{ 
          maxWidth: '1200px', 
          margin: '0 auto', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'space-between', 
          padding: '15px 20px',
          flexWrap: 'wrap',
          gap: '15px'
        }}>
          {/* Logo / Nombre - Cambiado a Lumin Nei */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '2rem' }}>🪷</span>
            <div>
              <h1 style={{ fontSize: '1.6rem', fontWeight: '400', letterSpacing: '3px', color: '#f3e8ff', margin: 0, fontFamily: 'serif' }}>
                Lumin Nei
              </h1>
              <span style={{ fontSize: '0.75rem', color: '#c084fc', letterSpacing: '1px' }}>Esencia y Consciencia Estelar</span>
            </div>
          </div>

          {/* Menú de Navegación */}
          <nav style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
            {['home', 'about', 'bibliography', 'photos', 'videos', 'contact'].map((tab) => {
              const labels = {
                home: 'Inicio',
                about: 'Acerca de',
                bibliography: 'Bibliografía',
                photos: 'Fotos',
                videos: 'Videos',
                contact: 'Contacto'
              };
              return (
                <button 
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  style={{
                    padding: '8px 16px',
                    fontSize: '0.9rem',
                    fontWeight: '500',
                    background: activeTab === tab ? 'rgba(168, 85, 247, 0.25)' : 'transparent',
                    border: activeTab === tab ? '1px solid rgba(168, 85, 247, 0.6)' : '1px solid transparent',
                    borderRadius: '20px',
                    cursor: 'pointer',
                    transition: 'all 0.3s',
                    color: activeTab === tab ? '#f3e8ff' : '#94a3b8'
                  }}
                >
                  {labels[tab]}
                </button>
              );
            })}
          </nav>
        </div>
      </header>

      {/* CONTENIDO PRINCIPAL */}
      <main style={{ padding: '40px 20px', maxWidth: '1152px', margin: '0 auto', flex: 1, width: '100%', boxSizing: 'border-box' }}>
        
        {/* 1. INICIO */}
        {activeTab === 'home' && (
          <div style={{ textAlign: 'center', maxWidth: '750px', margin: '60px auto', padding: '40px 20px', background: 'rgba(15, 15, 35, 0.6)', backdropFilter: 'blur(8px)', borderRadius: '20px', border: '1px solid rgba(168, 85, 247, 0.2)' }}>
            <span style={{ fontSize: '3.5rem' }}>🌌</span>
            <h2 style={{ fontSize: '2.6rem', fontWeight: '300', color: '#f3e8ff', marginBottom: '20px', letterSpacing: '2px', fontFamily: 'serif' }}>
              Bienvenidos a Lumin Nei
            </h2>
            <p style={{ fontSize: '1.15rem', color: '#e2e8f0', lineHeight: '1.8', marginBottom: '30px' }}>
              Un portal de sabiduría dedicado a la elevación de la consciencia, la sanación energética y la reconexión con la energía del universo. Sumérgete en nuestras enseñanzas y contenidos audiovisuales.
            </p>
            <button 
              onClick={() => setActiveTab('bibliography')}
              style={{
                backgroundColor: '#9333ea',
                color: '#ffffff',
                border: 'none',
                padding: '12px 32px',
                borderRadius: '30px',
                fontSize: '1rem',
                cursor: 'pointer',
                boxShadow: '0 4px 20px rgba(147, 51, 234, 0.5)',
                transition: 'background 0.2s',
                fontWeight: '500'
              }}
            >
              Explorar Bibliografía
            </button>
          </div>
        )}

        {/* 2. ACERCA DE */}
        {activeTab === 'about' && (
          <div style={{ background: 'rgba(15, 15, 35, 0.7)', backdropFilter: 'blur(12px)', padding: '40px', borderRadius: '20px', border: '1px solid rgba(168, 85, 247, 0.25)', maxWidth: '800px', margin: '0 auto' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '300', color: '#e9d5ff', marginBottom: '20px', fontFamily: 'serif' }}>Sobre Lumin Nei</h2>
            <p style={{ fontSize: '1.1rem', color: '#cbd5e1', lineHeight: '1.8', marginBottom: '20px' }}>
              En **Lumin Nei** impulsamos un espacio de transformación interior enfocado en expandir la luz de cada ser. A través de meditaciones profundas, textos de filosofía estelar y encuentros de autoconocimiento, guiamos el camino hacia la paz interior.
            </p>
            <p style={{ fontSize: '1.1rem', color: '#cbd5e1', lineHeight: '1.8' }}>
              Nuestra biblioteca recopila 100 documentos digitales y 100 conferencias preparadas para acompañar tu proceso de alineación y despertar espiritual.
            </p>
          </div>
        )}

        {/* 3. BIBLIOGRAFÍA (100 PDFs) */}
        {activeTab === 'bibliography' && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h2 style={{ fontSize: '2.4rem', fontWeight: '300', color: '#f3e8ff', fontFamily: 'serif' }}>Bibliografía y Textos Sagrados</h2>
              <p style={{ color: '#c084fc' }}>Colección de 100 archivos y guías espirituales para descargar.</p>
            </div>
            <div style={{ 
              maxHeight: '650px', 
              overflowY: 'auto', 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
              gap: '20px', 
              paddingRight: '10px' 
            }}>
              {pdfLibraryData.map((pdf) => (
                <div key={pdf.id} style={{ 
                  background: 'rgba(15, 15, 35, 0.65)', 
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(168, 85, 247, 0.2)', 
                  borderRadius: '14px', 
                  padding: '20px',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '10px' }}>
                      <span style={{ fontSize: '1.6rem' }}>📜</span>
                      <span style={{ fontSize: '0.8rem', background: 'rgba(147, 51, 234, 0.3)', color: '#e9d5ff', padding: '2px 8px', borderRadius: '10px' }}>
                        {pdf.fileSize}
                      </span>
                    </div>
                    <h3 style={{ fontSize: '1.1rem', color: '#f3e8ff', marginBottom: '8px' }}>{pdf.title}</h3>
                    <p style={{ fontSize: '0.9rem', color: '#94a3b8', lineHeight: '1.5', marginBottom: '15px' }}>{pdf.description}</p>
                  </div>
                  <a 
                    href={pdf.downloadLink} 
                    onClick={(e) => { e.preventDefault(); alert(`Descargando: ${pdf.title}`); }}
                    style={{ 
                      textAlign: 'center', 
                      backgroundColor: 'rgba(147, 51, 234, 0.3)', 
                      color: '#e9d5ff', 
                      padding: '8px', 
                      borderRadius: '8px', 
                      textDecoration: 'none', 
                      fontSize: '0.9rem',
                      border: '1px solid rgba(168, 85, 247, 0.4)',
                      fontWeight: '500'
                    }}
                  >
                    Descargar PDF
                  </a>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 4. FOTOS */}
        {activeTab === 'photos' && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h2 style={{ fontSize: '2.4rem', fontWeight: '300', color: '#f3e8ff', fontFamily: 'serif' }}>Galería de Luz</h2>
              <p style={{ color: '#c084fc' }}>Imágenes inspiradoras de armonía y geometría sagrada.</p>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '20px' }}>
              {photoGallery.map((photo, index) => (
                <div key={index} style={{ borderRadius: '14px', overflow: 'hidden', border: '1px solid rgba(168, 85, 247, 0.25)', background: 'rgba(15, 15, 35, 0.7)' }}>
                  <img src={photo.img} alt={photo.title} style={{ width: '100%', height: '200px', objectFit: 'cover', display: 'block' }} />
                  <div style={{ padding: '15px', textAlign: 'center' }}>
                    <h4 style={{ color: '#e2e8f0', fontSize: '1rem', margin: 0 }}>{photo.title}</h4>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 5. VIDEOS (100 Videos) */}
        {activeTab === 'videos' && (
          <div>
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
              <h2 style={{ fontSize: '2.4rem', fontWeight: '300', color: '#f3e8ff', fontFamily: 'serif' }}>Videos y Conferencias Estelares</h2>
              <p style={{ color: '#c084fc' }}>Biblioteca de 100 clases y sesiones guiadas.</p>
            </div>
            <div style={{ 
              maxHeight: '650px', 
              overflowY: 'auto', 
              display: 'grid', 
              gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', 
              gap: '20px', 
              paddingRight: '10px' 
            }}>
              {videoLibraryData.map((vid) => (
                <div key={vid.id} style={{ 
                  background: 'rgba(15, 15, 35, 0.65)', 
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(168, 85, 247, 0.2)', 
                  borderRadius: '14px', 
                  overflow: 'hidden',
                  display: 'flex',
                  flexDirection: 'column'
                }}>
                  <div style={{ position: 'relative', backgroundColor: '#000', height: '160px' }}>
                    <video 
                      src={vid.videoUrl} 
                      controls 
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    />
                  </div>
                  <div style={{ padding: '15px', display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between' }}>
                    <div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
                        <h3 style={{ fontSize: '1rem', color: '#f3e8ff', margin: 0 }}>{vid.title}</h3>
                        <span style={{ fontSize: '0.75rem', color: '#e9d5ff', background: 'rgba(147, 51, 234, 0.3)', padding: '2px 8px', borderRadius: '6px' }}>{vid.duration}</span>
                      </div>
                      <p style={{ fontSize: '0.85rem', color: '#94a3b8', lineHeight: '1.4', margin: 0 }}>{vid.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* 6. CONTACTO */}
        {activeTab === 'contact' && (
          <div style={{ background: 'rgba(15, 15, 35, 0.7)', backdropFilter: 'blur(12px)', padding: '40px', borderRadius: '20px', border: '1px solid rgba(168, 85, 247, 0.25)', maxWidth: '600px', margin: '0 auto', textAlign: 'center' }}>
            <h2 style={{ fontSize: '2.2rem', fontWeight: '300', color: '#e9d5ff', marginBottom: '15px', fontFamily: 'serif' }}>Conecta con Lumin Nei</h2>
            <p style={{ color: '#94a3b8', marginBottom: '30px' }}>Envíanos tus inquietudes o solicitud de talleres.</p>
            
            <form onSubmit={(e) => { e.preventDefault(); alert('Mensaje enviado a Lumin Nei.'); }} style={{ display: 'flex', flexDirection: 'column', gap: '15px', textAlign: 'left' }}>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', color: '#cbd5e1', marginBottom: '5px' }}>Nombre</label>
                <input type="text" placeholder="Tu nombre" required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid rgba(168, 85, 247, 0.3)', background: 'rgba(10, 10, 25, 0.8)', color: '#fff', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', color: '#cbd5e1', marginBottom: '5px' }}>Correo Electrónico</label>
                <input type="email" placeholder="tu@correo.com" required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid rgba(168, 85, 247, 0.3)', background: 'rgba(10, 10, 25, 0.8)', color: '#fff', boxSizing: 'border-box' }} />
              </div>
              <div>
                <label style={{ display: 'block', fontSize: '0.85rem', color: '#cbd5e1', marginBottom: '5px' }}>Mensaje</label>
                <textarea rows="4" placeholder="Escribe tu mensaje aquí..." required style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid rgba(168, 85, 247, 0.3)', background: 'rgba(10, 10, 25, 0.8)', color: '#fff', boxSizing: 'border-box', resize: 'vertical' }}></textarea>
              </div>
              <button type="submit" style={{ backgroundColor: '#9333ea', color: '#ffffff', border: 'none', padding: '12px', borderRadius: '25px', fontSize: '1rem', cursor: 'pointer', fontWeight: '500', marginTop: '10px' }}>
                Enviar Mensaje
              </button>
            </form>
          </div>
        )}

      </main>

      {/* PIE DE PÁGINA */}
      <footer style={{ textAlign: 'center', padding: '25px', color: '#94a3b8', fontSize: '0.85rem', borderTop: '1px solid rgba(168, 85, 247, 0.15)', marginTop: '40px', backgroundColor: 'rgba(10, 10, 25, 0.8)' }}>
        Copyright © 2026 HH-II - Todos los derechos reservados.
      </footer>
    </div>
  );
}